export default __webpack_public_path__ + "static/media/avatar.ca7543eb.png";